import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils/index.ts';
import { motion } from 'framer-motion';
import {
  Plus,
  LayoutDashboard,
  Search,
  BookOpen,
  BarChart3,
  Building2,
  Users,  
  Ticket,
  FileText,
  Info,
  ArrowRight
} from 'lucide-react';

const QuickAction = ({ icon: Icon, title, description, href, color, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay }}
    className="group relative"
  >
    <Link
      to={href}
      className={`
        relative flex flex-col items-center gap-4 p-6 rounded-xl overflow-hidden
        border border-border/50 transition-all duration-300
        hover:border-${color}/50 hover:shadow-lg hover:-translate-y-1
        ${color === 'red' ? 'hover:bg-red-500/5' : 
          color === 'blue' ? 'hover:bg-blue-500/5' : 
          color === 'green' ? 'hover:bg-green-500/5' : 
          color === 'purple' ? 'hover:bg-purple-500/5' : 
          color === 'yellow' ? 'hover:bg-yellow-500/5' : 
          color === 'orange' ? 'hover:bg-orange-500/5' : 
          'hover:bg-primary/5'}
      `}
    >
      <div className={`
        rounded-lg p-3
        ${color === 'red' ? 'bg-red-500/10 text-red-500' : 
          color === 'blue' ? 'bg-blue-500/10 text-blue-500' : 
          color === 'green' ? 'bg-green-500/10 text-green-500' : 
          color === 'purple' ? 'bg-purple-500/10 text-purple-500' : 
          color === 'yellow' ? 'bg-yellow-500/10 text-yellow-500' : 
          color === 'orange' ? 'bg-orange-500/10 text-orange-500' : 
          'bg-primary/10 text-primary'}
      `}>
        <Icon className="w-6 h-6" />
      </div>
      
      <div className="text-center">
        <h3 className="font-medium mb-1">{title}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>

      <div className={`
        absolute bottom-4 right-4 opacity-0 transform translate-x-4
        group-hover:opacity-100 group-hover:translate-x-0
        transition-all duration-300
        ${color === 'red' ? 'text-red-500' : 
          color === 'blue' ? 'text-blue-500' : 
          color === 'green' ? 'text-green-500' : 
          color === 'purple' ? 'text-purple-500' : 
          color === 'yellow' ? 'text-yellow-500' : 
          color === 'orange' ? 'text-orange-500' : 
          'text-primary'}
      `}>
        <ArrowRight className="w-5 h-5" />
      </div>
    </Link>
  </motion.div>
);

export default function QuickActions({ isAdmin }) {
  const actions = [
    {
      icon: Ticket,
      title: "Novo Chamado",
      description: "Criar um novo chamado",
      href: createPageUrl("NewTicket"),
      color: "blue",
      delay: 0
    },
    {
      icon: Search,
      title: "Pesquisar Chamados",
      description: "Buscar por chamados existentes",
      href: createPageUrl("Tickets"),
      color: "purple",
      delay: 0.1
    },
    {
      icon: BookOpen,
      title: "Base de Conhecimento",
      description: "Acessar artigos e soluções",
      href: createPageUrl("Knowledge"),
      color: "green",
      delay: 0.2
    },
    {
      icon: BarChart3,
      title: "Relatórios",
      description: "Ver estatísticas e métricas",
      href: createPageUrl("Reports"),
      color: "orange",
      delay: 0.3
    }
  ];

  // Adicionar ações exclusivas para administradores
  if (isAdmin) {
    actions.push(
      {
        icon: Building2,
        title: "Novo Cliente",
        description: "Cadastrar novo cliente",
        href: createPageUrl("NewClient"),
        color: "yellow",
        delay: 0.4
      },
      {
        icon: Users,
        title: "Gerenciar Usuários",
        description: "Administrar usuários do sistema",
        href: createPageUrl("Users"),
        color: "red",
        delay: 0.5
      }
    );
  }

  return (
    <div className="mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {actions.map((action, index) => (
          <QuickAction key={index} {...action} />
        ))}
      </div>
    </div>
  );
}